import React, { useState, useCallback } from 'react';
import { Tooltip, IconButton, makeStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { useHotkeys } from 'react-hotkeys-hook';
import buttonStyles from './styles';

const useStyles = makeStyles(() => ({
  debugContainer: {
    display: 'inline',
    position: 'relative',
  },
  debugContent: {
    position: 'absolute',
    width: '300px',
    height: '390px',
    backgroundColor: '#f5f6fa',
    opacity: '0.9',
    borderRadius: 24,
    border: '4px dashed #ff5a0f',
    zIndex: 8,
    padding: '20px',
  },
}));

type Props = {
  debugInfo?: string[];
};

const LabelDebugInfoButton = (props: Props) => {
  const buttonClasses = buttonStyles();
  const classes = useStyles();
  const {
    debugInfo
  } = props;

  const [showDebugInfo, setShowDebugInfo] = useState<boolean>(false);
  
  const toggleDebugInfo = useCallback(() => {
    setShowDebugInfo(value => !value);
  }, []);
  useHotkeys('d', toggleDebugInfo, { keydown: false, keyup: true }, [toggleDebugInfo]);
  
  let di: number = 0;
  const debugElement = debugInfo && debugInfo.map((d: string) => <div key={di++}>{d}</div>);

  return (
    <React.Fragment>
      <Tooltip title={'[ D ] Toggle Debug Info'} arrow>
        <IconButton
          onClick={toggleDebugInfo}
          className={showDebugInfo ? buttonClasses.toggleIconActive : buttonClasses.toggleIcon}>
          <InfoIcon />
        </IconButton>
      </Tooltip>
      { showDebugInfo && <div className={classes.debugContainer}>
        <div className={classes.debugContent}>
          { debugElement }
        </div>
      </div> }
    </React.Fragment>
  );
};

export default LabelDebugInfoButton;
